import { createFileRoute } from '@tanstack/react-router'
import { CapabilityPage } from '@/components/engineering/EngineeringPages'
import { TaggedPosts } from '@/components/lab/LabBlocks'
import { useTranslation } from 'react-i18next'
import { localizedPageHead } from '@/lib/seo-head'
export const Route = createFileRoute('/{-$locale}/iot')({
  head: ({ params }) => localizedPageHead('iot', params.locale),
  component: IotPage,
})
function IotPage() {
  const { t } = useTranslation('lab')
  return (
    <>
      <CapabilityPage kind="iot" />
      <TaggedPosts tag="iot" title={t('iot.postsTitle')} />
    </>
  )
}
